import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const tcpApi = {
  getBroadcast: (request) => {
    const { params } = request
    return instance().get('api/tcp/broadcast/summary', {
      params
    })
  },
  getMemberLevel: (request) => {
    const { params } = request
    return instance().get('api/tcp/member_level', {
      params
    })
  },
  getBroadcastByPageToken: (request) => {
    const { params } = request
    return instance().get('v1/tcp/broadcast/summary', {
      params,
      headers: {
        AUTHORIZATION: `Bearer ${store.state.pageToken}`
      }
    })
  },
  getMemberLevelByPageToken: (request) => {
    const { params } = request
    return instance().get('v1/tcp/member_level', {
      params,
      headers: {
        AUTHORIZATION: `Bearer ${store.state.pageToken}`
      }
    })
  }
}
export default tcpApi



// WEBPACK FOOTER //
// ./src/api/tcp.js